import MatchShapes from "../../components/UKG/Mathematics/MatchShapes";
import MatchShapesWithObjects from "../../components/UKG/Mathematics/MatchShapesWithObjects";


// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

document.title = "Mamas Guidance - UKG - Mathematics - Shapes";

const topics: MenuItem[] = [
    { url: "/ukg/mathematics/shapes/match-shapes", title: "Match Shapes", component: MatchShapes},
    { url: "/ukg/mathematics/shapes/match-shapes-with-object", title: "Match Shapes with Object", component: MatchShapesWithObjects},
];


export default topics;